// Lib
import { size } from 'lodash/fp';

// Selectors
import { trashEarliestTimestampSelector, trashHasMoreSelector } from './trashSelector';

// Service
import { emptyTrashService, fetchTrashService } from './trashService';
import { asyncResource } from '../../../../utils/services/http/asyncResource/asyncResource';

// Actions
import { loadElements } from '../../../../../common/elements/elementActions';
import { commentsLoad } from '../../../../../common/comments/commentActions';

// Constants
import { ResourceTypes } from '../../../../utils/services/http/asyncResource/asyncResourceConstants';
import { TRASH_CLEAR_COMPLETE, TRASH_CLEAR_START, TRASH_CLEAR_FAILED, TRASH_TABS } from './trashConstants';

export const emptyTrash = () => async (dispatch) => {
    // Show the loading state
    dispatch({ type: TRASH_CLEAR_START });

    await emptyTrashService()
        .then(() => dispatch({ type: TRASH_CLEAR_COMPLETE }))
        .catch((error) => dispatch({ type: TRASH_CLEAR_FAILED, error }));
};

export const fetchTrash =
    ({ before, beforeId, tab } = {}) =>
    async (dispatch, getState) =>
        dispatch(
            asyncResource(
                ResourceTypes.trash,
                tab,
                // Only force fetch if we're not getting the initial batch of trash
                !!before,
            )(async () => {
                const otherUsers = tab === TRASH_TABS.OTHERS;

                const { elements, comments, hasMore, hasOlderTrash, earliestTimestamp } = await fetchTrashService({
                    before,
                    beforeId,
                    otherUsers,
                });

                if (size(comments)) dispatch(commentsLoad({ comments }));

                dispatch(loadElements(elements));

                return {
                    hasMore,
                    hasOlderTrash,
                    earliestTimestamp,
                };
            }),
        );

export const fetchNextPageOfTrash =
    ({ tab }) =>
    async (dispatch, getState) => {
        const state = getState();
        const hasMore = trashHasMoreSelector(tab)(state);

        if (!hasMore) return;

        const earliestTimestamp = trashEarliestTimestampSelector(tab)(state);
        return dispatch(fetchTrash({ before: earliestTimestamp, tab }));
    };
